import { defineComponent as B, useSlots as j, useAttrs as k, ref as C, createBlock as O, openBlock as v, resolveDynamicComponent as w, h as D } from "vue";
import { findChildrenVNodes as G } from "../util.js";
const P = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "AutoWrap",
  props: {
    component: { type: [String, Object, Symbol, Function] },
    include: { type: [Array, String, Object, Symbol, Function] },
    exclude: { type: [Array, String, Object, Symbol, Function] },
    each: { type: Boolean },
    force: { type: Boolean },
    options: {}
  },
  setup(h, { expose: y }) {
    function p(e, n = !0) {
      if (typeof e == "function")
        return e;
      let r = [];
      return e && (r = Array.isArray(e) ? e : [e]), r.length ? (c) => r.includes(c.type) : () => n;
    }
    const t = h, f = j(), m = k(), a = C(null);
    function g(e, n, r, c, A, F) {
      if (!n)
        return e;
      const S = p(r), b = p(c, !1), l = w(n), _ = { ...m, ref: (o) => a.value = o }, i = (o, d) => D(o, _, typeof n == "string" ? d : () => d), u = [];
      let s = [];
      for (const o of e)
        n !== o.type && S(o) && !b(o) ? A ? u.push(i(l, o)) : s.push(o) : (s.length && (u.push(i(l, s)), s = []), u.push(o));
      return s.length && u.push(i(l, s)), !F && !u.length ? null : u;
    }
    function x() {
      if (!f.default)
        return;
      const e = f.default();
      let n = G(e);
      const r = t.options ?? [{
        component: t.component,
        include: t.include,
        exclude: t.exclude,
        each: t.each,
        force: t.force
      }];
      for (const c of r)
        n = g(
          n,
          c.component ?? t.component,
          c.include ?? t.include,
          c.exclude ?? t.exclude,
          c.each ?? t.each,
          c.force ?? t.force
        ) ?? n;
      return n;
    }
    return y({
      el: a
    }), (e, n) => (v(), O(x));
  }
});
export {
  P as default
};
